export default "/public/dist/img/banner10.jpg";